import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogConfig } from '@mtgame/ui';
import { MediaItem } from '@mtgame/core';

@Component({
  selector: 'mtg-video-detail',
  templateUrl: './video-detail.component.html',
  styleUrls: ['./video-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoDetailComponent {
  media: MediaItem;

  constructor(
    private dialogConfig: DialogConfig
  ) {
    this.media = this.dialogConfig.data.media;
  }
}
